export default {
    methods: {
      async selectedTariff(reset){
        this.clength_loading = true;
        this.clength_disabled = true;
        let tariff = this.findTariffById(this.tariffID);
        this.formData.tariff = tariff;
        this.clength_list = tariff.cLength;
        this.clength_loading = false;
        this.clength_disabled = false;
        if(reset){
          this.cLength = '';
          this.promo = '';
          this.formData.cLength = '';
          this.formData.promo = {id:'',name:'',price:0};
          this.promos_disabled = true;
        }
      },
      async selectedLength(reset){
        this.promos_loading = true;
        this.promos_disabled = true;

        this.formData.cLength = this.cLength;
        const tariff = this.findTariffById(this.tariffID);
        const promos = tariff.promos.filter(e=> e.available && e.promo.min_contract_length_months<=parseInt(this.cLength) ).map(e=>({
          text: e.promo.name,
          value: e.promo.id,
        }));
        this.promos_list = [{text: 'No Promo',value: null}].concat(promos);

        this.promos_disabled = false;
        this.promos_loading = false;
        if(reset){
          this.promo = '';
          this.formData.promo = {id:'',name:'',price:0};
        }
      },
      async selectedPromo() {
        if (this.promo === '') {
          this.formData.promo = { id: '', name: '', price: 0 };
        } else {
          const promo = this.getPromoById(this.promo);
          this.formData.promo = promo;
          if (promo && promo.required_charges && promo.required_charges.length) {
            this.formData.tariff.required_charges = promo.required_charges;
          }
        }
      },
      findContractLengths(length){
        let lengths = [1,12,18,24,36,48];
        lengths = lengths.splice(lengths.indexOf(length));
        let allLengths = [];
        lengths.forEach(len=>{
          if(len===1){
            allLengths.push({text: `Month to Month`,value: 1});
          }else{
            allLengths.push({text: `${len} Months`,value: len});
          }
        });
        return allLengths;
      },
      async sortTariffs(){
        let tariffs = {};
        let tariffList = [];
        let promos = [];

        this.productAllTariffs.forEach((tar)=>{
          if(tar.product_kind.toLowerCase()==='voipseat'){
            tariffs[tar.id] = {
              id: tar.id,
              name: tar.name,
              promos: tar.promos,
              price: parseFloat(tar.standard_price),
              addons: tar.addons,
              cLength: this.findContractLengths(tar.min_contract_length_months),
              required_charges: tar.required_charges,
              included_child_charges: tar.included_child_charges,
            };
            tariffList.push({
              text: tar.name,
              value: tar.id,
              promos: tar.promos,
              addons: tar.addons,
              available: tar.available,
              service: tar.service,
            });
            tar.promos.forEach(pro => {
              promos.push(pro.promo);
            });
          }
        });
          
        let allPromos = {};
        promos.forEach((pro)=>{
          allPromos[pro.id] = {
            id: pro.id,
            name: pro.name,
            price: parseFloat(pro.price),
            required_charges: pro.required_charges,
          };
        });
        this.allPromos = allPromos;
        this.tariffs = tariffs;
        this.tariffs_list = tariffList.filter(e=>(e.available));
      },
      findTariffById(id){
        return (id===null||id===undefined)?{id:'',addons:[],name: '-',price:0}:this.tariffs[id];
      },
      getPromoById(id){
        return (id===null||id===undefined)?{id:'',name: '-',price:0}:this.allPromos[id];
      },
    },
  };